import { ARTICLE_TOKENS } from './design-tokens';
import type { ArticleHeading } from '@lib/article-blocks/headings';

export const TableOfContents = ({
  headings
}: {
  headings: ArticleHeading[];
}) => {
  if (headings.length === 0) return null;
  return (
    <nav
      aria-label="In this article"
      className={`mb-11 rounded-[14px] border px-6 py-[22px] ${ARTICLE_TOKENS.rule} ${ARTICLE_TOKENS.surfaceTint}`}
      data-cy="article-toc"
    >
      <div
        className={`mb-3.5 font-body tabular-nums text-[11px] uppercase tracking-[0.1em] ${ARTICLE_TOKENS.muted}`}
      >
        In this article
      </div>
      <ol className="m-0 grid list-none grid-cols-1 gap-x-7 gap-y-2.5 p-0 sm:grid-cols-2">
        {headings.map((heading, index) => (
          <li key={heading.id} className="flex items-baseline gap-2.5">
            <span
              className={`font-body tabular-nums text-[11px] ${ARTICLE_TOKENS.mutedLighter}`}
            >
              {String(index + 1).padStart(2, '0')}
            </span>
            <a
              href={`#${heading.id}`}
              className={`font-heading text-[14.5px] font-semibold leading-[1.35] no-underline hover:text-[#1f7fc4] ${ARTICLE_TOKENS.ink}`}
            >
              {heading.text}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
};
